<template>
  <div class="addContact">
    <div class="title">
      <div class="left">
        <span class="span">温馨提示：授权通讯录权限，以及填写更多有效联系人，有助于提高审核通过率哦～</span>
      </div>
    </div>
    <!-- 联系人信息 -->
    <div class="contactInfo">
      <div
        class="contactInfo-item"
        v-for="(item, index) in contactReqs"
        :key="index"
      >
        <div class="item-title">
          <img src="@/assets/style/contactInfo-icon.png" alt="" />
          <span>联系人{{ index + 1 }}</span>
        </div>
        <div
          v-if="$VUE_APP_ENV === 'productionApp'"
          class="select-contact"
          @click="selectContact(index)"
        >
          <span>通讯录选取</span>
          <img src="@/assets/style/phone-right-icon.png" alt="" />
        </div>
        <div
          v-if="index > 1"
          class="delete-contact"
          @click="deleteContact(index)"
        >
          <img src="@/assets/style/phone-delect.png" alt="" />
        </div>
        <div class="name">
          <div class="label"><span class="required">*</span>联系人</div>
          <div class="value">
            <input
              v-model="item.contactName"
              type="text"
              placeholder="请输入联系人姓名"
            />
          </div>
        </div>
        <div class="phone">
          <div class="label"><span class="required">*</span>手机号</div>
          <div class="value">
            <input
              v-model="item.contactPhone"
              type="tel"
              inputmode="numeric"
              maxlength="11"
              placeholder="请输入联系人手机号"
              @input="handlePhoneInput(item)"
            />
          </div>
        </div>
        <div class="relation">
          <div class="label"><span class="required">*</span>关系</div>
          <div class="value" @click="handleClick(index)">
            <span class="span">{{ item.contactRelation || "请选择关系" }}</span>
            <img
              class="relation-icon"
              src="@/assets/style/oride-icon.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <!--添加联系人-->
    <div class="addContact-footer" @click="addContact">
      <div class="addContact-title">
        +
        <span>添加联系人</span>
      </div>
    </div>
    <!--确定-->
    <div class="confirm" @click="confirm" v-fixed-bottom>
      <div class="confirm-title" :class="{ disabled: disabled }">
        <span>提交资料</span>
      </div>
    </div>
    <div class="block" v-fixed-bottom></div>
    <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
  </div>
</template>

<script>
import { addContact ,addContacts} from "@/api/index";
import { getLocalStorageData } from "@/common/index.js";

export default {
  name: "AddContact",
  components: {},
  data() {
    return {
      contactReqs: [
        {
          contactName: "",
          contactPhone: "",
          contactRelation: "直系亲属",
        },
        {
          contactName: "",
          contactPhone: "",
          contactRelation: "同事",
        },
      ],
      show: false,
      actions: [
        { name: "直系亲属" },
        { name: "同事" },
        { name: "朋友" },
        { name: "其他" },
      ],
      index: 0,
    };
  },
  async mounted() {
    setTimeout(() => {
      this.$JSBridge.send("serviceType", { type: "3" });
       this.$JSBridge.listen("pushContacts", (res) => {
      console.log(res, "pushContacts");
      this.handleBatchUploadContacts(res.data.result);
      });
    }, 1000);
  },
   activated() {
    const userAllInfo = getLocalStorageData("UserAllInfo");
    if (userAllInfo.contactList.length > 0) {
      this.contactReqs = userAllInfo.contactList.map((item) => ({
        contactName: item.contactName || "",
        contactPhone: item.contactPhone || "",
        contactRelation: this.actions.some(option => option.name == item.contactRelation) ? item.contactRelation : "",
      }));
    }
  },
  methods: {
    /**
     * 批量上传通讯录方法
     */
    async handleBatchUploadContacts(result) {
     addContacts(result.map(item => ({
      contactName: item.name,
      contactPhone: item.phone,
     })))
    },

    handlePhoneInput(item) {
      if (!item) return;
      const digits = String(item.contactPhone || "")
        .replace(/\D/g, "")
        .slice(0, 11);
      item.contactPhone = digits;
    },
    deleteContact(index) {
      this.contactReqs.splice(index, 1);
    },
    selectContact(index) {
      this.$JSBridge.remove("pushContact");
      this.$JSBridge.send("serviceType", { type: "4" });
      this.$JSBridge.listen("pushContact", (res) => {
        console.log(
          res.data.name,
          "pushContact事件111",
          res.type,
          res.data.phone,
        );
        if (res.type == "4") {
          this.contactReqs[index].contactName = res.data.name;
          this.contactReqs[index].contactPhone = res.data.phone;
        }
      });
    },
    handleClick(index) {
      this.index = index;
      this.show = true;
    },
    onSelect(item) {
      this.contactReqs[this.index].contactRelation = item.name;
      this.show = false;
    },
    addContact() {
      this.contactReqs.push({
        contactName: "",
        contactPhone: "",
        contactRelation: "",
      });
    },
    confirm() {
      if (this.disabled) return;
      addContact(this.contactReqs).then((res) => {
        console.log(res, "res");
        if (res.code === 2000) {
          this.$toast("添加成功");
          this.$emit("confirm", this.contactReqs);
        } else {
          this.$toast(res.msg || res.message || "添加失败");
        }
      });
    },
  },
  computed: {
    disabled() {
      return this.contactReqs.some(
        (item) =>
          !item.contactName || !item.contactPhone || !item.contactRelation,
      );
    },
  },
};
</script>

<style scoped lang="scss">
.addContact {
  overflow: auto;
}
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left {
    display: flex;
    flex-direction: column;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    .span {
      font-size: 12px;
      color: #D4A038;
    }
  }
  .right {
    width: 80px;
    height: 37px;
    background: #01abff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #ffffff;
    border-radius: 8px;
  }
}
.contactInfo {
  margin-top: 16px;
}
.contactInfo-item {
  background: #fff;
  border-radius: 12px;
  padding: 16px 16px 16px 21px;
  margin-bottom: 16px;
  position: relative;
  .item-title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    img {
      width: 8px;
      height: 8px;
      margin-right: 10px;
    }
  }
  .name,
  .phone,
  .relation {
    display: flex;
    align-items: center;
    height: 44px;
    border-radius: 8px;
    margin-top: 12px;
    .label {
      width: 70px;
      color: #333333;
      font-size: 14px;
      .required {
        color: #ff0000;
      }
    }
    .value {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #f8f8f8;
      border-radius: 17px;
      height: 33px;
      font-size: 14px;
      color: #333333;
      flex: 1;
    }
    input {
      border: none;
      outline: none;
      display: flex;
      align-items: center;
      background: transparent;
      padding-left: 28px;
      &::placeholder {
        color: #777777;
      }
    }
    .span {
      font-size: 14px;
      color: #333333;
      padding-left: 28px;
    }
    .relation-icon {
      height: 20px;
      margin-right: 10px;
      transform: rotate(90deg);
    }
  }
  .relation {
    margin-bottom: 24px;
  }
}
.addContact-footer {
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  border-radius: 8px 8px 8px 8px;
  background: #fff;
  color: #F24334;
}
.confirm {
  position: fixed;
  bottom: 0;
  width: 100%;
  left: 0;
  background: #ffffff;
  box-shadow: 0px -2px 19px 0px rgba(0, 0, 0, 0.15),
    0px 1px 7px 0px rgba(0, 0, 0, 0.15);
  height: 120px;
  display: flex;
  align-items: center;
  .confirm-title {
    border-radius: 30px;
    color: #fff;
    background: #F24334;
    height: 51px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0px 16px;
    width: 100%;
  }
  .disabled {
    background: #FFC2BD;
    cursor: not-allowed;
  }
}
.block {
  height: 125px;
  width: 100%;
}
.select-contact {
  position: absolute;
  right: 0px;
  top: 0px;
  background: #e0ebff;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 12px;
  color: #D4A038;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    height: 12px;
    margin-left: 4px;
  }
}
.delete-contact {
  position: absolute;
  right: 0px;
  bottom: 0px;
  img {
    width: 50px;
  }
}
</style>
